import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CareerForm from './components/CareerForm';
import ResultsSection from './components/ResultsSection';
import { getCareerRecommendations } from './data/careerData';

function App() {
  const [recommendations, setRecommendations] = useState([]);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const handleFormSubmit = async (formData) => {
    setLoading(true);
    
    // Simulate AI processing delay
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    // Get career recommendations
    const careerRecommendations = getCareerRecommendations(
      formData.stream,
      parseFloat(formData.marks),
      formData.interests
    );
    
    setUserData(formData);
    setRecommendations(careerRecommendations);
    setShowResults(true);
    setLoading(false);
  };

  const handleReset = () => {
    setShowResults(false);
    setRecommendations([]);
    setUserData(null);
  };

  return (
    <div className="App">
      <div className="container" style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{ textAlign: 'center', marginBottom: '3rem' }}
        >
          <h1 style={{ 
            fontSize: '3rem', 
            fontWeight: '800', 
            color: 'white',
            marginBottom: '1rem',
            textShadow: '0 4px 8px rgba(0, 0, 0, 0.3)'
          }}>
            🎯 Career AI
          </h1>
          <p style={{ 
            fontSize: '1.25rem', 
            color: 'rgba(255, 255, 255, 0.9)',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            Discover your perfect career path with AI-powered recommendations based on your 12th marks and interests
          </p>
        </motion.div>

        <AnimatePresence mode="wait">
          {!showResults ? (
            <motion.div
              key="form"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
              transition={{ duration: 0.5 }}
            >
              <CareerForm onSubmit={handleFormSubmit} loading={loading} />
            </motion.div>
          ) : (
            <motion.div
              key="results"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.5 }}
            >
              <ResultsSection
                recommendations={recommendations}
                userData={userData}
                onReset={handleReset}
              />
            </motion.div>
          )}
        </AnimatePresence>

        {/* Footer */}
        <motion.footer
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1 }}
          style={{
            textAlign: 'center',
            marginTop: '4rem',
            padding: '2rem 0',
            color: 'rgba(255, 255, 255, 0.8)',
            borderTop: '1px solid rgba(255, 255, 255, 0.2)'
          }}
        >
          <p style={{ marginBottom: '0.5rem' }}>
            Made with ❤️ using React & AI
          </p>
          <p style={{ fontSize: '0.875rem' }}>
            This is a demo application. Career recommendations are based on mock data and should not be considered as professional advice.
          </p>
        </motion.footer>
      </div>
    </div>
  );
}

export default App; 